module.exports = __webpack_public_path__ + "static/media/Netflix-Logo.e22641df.png";